import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import CommittedExpendituresIndexList from './CommittedExpendituresIndexList';

export default function CommittedExpendituresIndex() {
    return (
        <>
            <h5 className="text-blue font-weight-600 mb-2">
                {'Department: ' + department.name} {costcenter !== undefined ?? ' - Cost Center: ' + costcenter.name}
            </h5>
            <CommittedExpendituresIndexList
                committedExpendituresIndexUrl={committedExpendituresIndexUrl}
                suppliersIndexUrl={suppliersIndexUrl}
                committedExpendituresUpdateUrl={committedExpendituresUpdateUrl}
                uncommittedExpendituresCreateUrl={uncommittedExpendituresCreateUrl}
                uncommittedExpendituresDetailsUrl={uncommittedExpendituresDetailsUrl}
            />
        </>
    );
}

if (document.getElementById('CommittedExpendituresIndex')) {
    var rootEl = document.getElementById('CommittedExpendituresIndex');
    ReactDOM.render(
        <App>
            <CommittedExpendituresIndex />
        </App>,
        rootEl,
    );
}
